export interface IChartTemplateRound {
  id?: number;
  label?: string;
  sequence?: number;
  groupSequence?: number;
}

export const defaultValue: Readonly<IChartTemplateRound> = {};
